<template lang="pug">
extends ../../../components/filter/dynamic-filter-template.pug

block item
    template(#receipts.drawer_session_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} <br/>
            small.text-muted
                | {{ props.value.staff_name }}

    template(#receipts.day_operation_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }}
                br

            small.text-muted
                | {{ props.value.staff_name }}

    template(#labels.id="props")
        label-badge(
            :labelName="props.value.display_name"
            :backgroundColor="props.value.bg"
        )
    
    template(#receipt_payments.payment_id="props")
        div(v-if="payment") 
            span.block {{ props.value.display_name}}
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import dynamicFilterBase from '@js/components/filter/dynamic-filter-base';
import labelBadge from '@js/components/label/label-badge.vue';
import tillFilterMixin from '@js/components/till-filter/till-filter-mixin';
import Report from '@js/plugins/report';
import Auth from '@js/plugins/auth';

export default {
    components: { labelBadge },

    extends: dynamicFilterBase,

    mixins: [tillFilterMixin],

    props: {
        payment: {
            type: Boolean | Number,
            default: false,
        },

        hide_till: {
            type: Boolean | Number,
            default: false,
        },
    },

    data() {
        let that = this;

        return {
            preSelectOperator: true,
            returnOperatorValueList: true,

            externalRemotes: {
                labels(query) {
                    return that
                        .getLabelListIfNecessary({ query })
                        .then(data => {
                            return data.map(d => ({
                                id: d.id,
                                display_name: d.name,
                                bold: d.parent_id == null,
                                bg: d.color,
                            }));
                        });
                },
                payment(query) {
                    return that
                        .getPaymentListIfNecessary({ query })
                        .then(data => {
                            // Only add OPT option if environment is not 'xcel'
                            if (that.environment !== 'xcel') {
                                let opt = {
                                    id: 'OPT',
                                    type: 1,
                                    name: 'OPT',
                                    require_reference: false,
                                    require_drawer_kick: false,
                                    is_apply_rounding: 0,
                                    is_allow_split_payment: 0,
                                    preset_amount: null,
                                    source: 'eps_invenco',
                                    force_receipt_printing: 0,
                                    receipt_copies: 0,
                                    created_at: '2022-03-08T13:46:32+0800',
                                    updated_at: '2022-03-08T13:46:32+0800',
                                    deleted_at: null,
                                    meta: {},
                                    outlets: [],
                                };

                                data = [...data, opt];
                            }

                            return data.map(d => ({
                                id: d.id,
                                display_name: d.name,
                            }));
                        });
                },
            },
        };
    },

    computed: {
        ...mapGetters(['activeOutlet', 'startDate', 'endDate']),

        ...mapState('paymentReport', ['filters', 'searchMeta']),

        loading() {
            return this.onLoading('get-meta');
        },

        environment() {
            return Auth.metas().environment;
        },
    },

    created() {
        let hideCustomFilterComponent = [];

        if (this.payment) {
            hideCustomFilterComponent.push('Payment');
        }

        if (this.hide_till) {
            hideCustomFilterComponent.push('Till Closure');
            hideCustomFilterComponent.push('Till Summary');
        }

        if (Report.pgsqlStrategy('payment')) {
            this.getSearchMetaIfNecessaryV2(hideCustomFilterComponent);
        } else {
            this.getSearchMetaIfNecessary(hideCustomFilterComponent);
        }

        this.getLabelListIfNecessary();
        this.getPaymentListIfNecessary();
    },

    methods: {
        ...mapActions('label', ['getLabelListIfNecessary']),

        ...mapActions('paymentReport', [
            'getSearchMetaIfNecessary',
            'getSearchMetaIfNecessaryV2',
        ]),

        ...mapMutations('paymentReport', ['setFilters']),

        ...mapActions('payment', ['getPaymentListIfNecessary']),
    },
};
</script>
